import React from "react";
import YouTube from 'react-youtube'


function Body () {
    return (
        <div className="body-body">
            <div className="content">
                <div className="body-words">
                    <h1>Sign Language Ghana</h1>
                    <p>Sign language facilitator at vodafone ghana and teacher with Devio educational institute, Canada.</p>
                    <img src="./images/body-image.jpg" className="body-image"/>  
                </div>
                <div className="yt">
                    <YouTube videoId={'_lRyFX1efoo'}/>
                </div>
            </div>
        </div>
    );
}


export default Body